const numberWithCommas = (number: number) => {
  const parts = Number(number).toFixed(2).toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
};

export default numberWithCommas;
